<template>
    <div class="bg">
        <img src="@/assets/home/bgLeft.png" alt="" class="bgLeft">
        <img src="@/assets/home/bgRight.png" alt="" class="bgRight">
        <div class="page animate__animated  animate__fadeIn">
            <div class="introduce">
                <div class="title">
                    COMPANY PROFILE
                    <h1>公司简介</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
                <div class="top">
                    <div class="text animate__animated animate__fadeInLeft">
                        <p>南京星谱智信息科技有限公司创立于 2022年4月，由南京航空航天大学国际创新港和南京市六合区政府共同投资创建。公司集中办公注册地南京市六合区雄州街道王桥路57号科创中心B座2楼，现有办公场所占地建筑总面积约5868平方米。南京星谱智信息科技有限公司（以下简称“公司”）研发和管理人员主要来自南京航空航天大学、南京理工大学、南京工业大学、河海大 学以及扬州大学、中国科学院大学、西北工业大学、西安电子科技大学 等著名高校与研究院（所），学历层次高、创新意识强、年轻有活力。公司创始人和核心团队具有深厚的基础理论成果、扎实的技术实力、丰富的产品研发经验和先进的现代化管理理念。</p>
                        <p>公司所从事的开发研究以“电磁频谱管控、天地一体化网络、无人机 集群智能组网”等重大应用需求为主要攻关方向；以“频谱区块链、6G频谱共享共存”前沿成果行业标准和专利群为研究领域；以无人机频谱认知仪、低空智联网安全、电磁频谱仿真等软硬件产品成果产学研用一体化为产业化发展方向。公司同时专注于物联网、云计算、大数据技术在智慧园区领域应用研究，为客户提供智慧园区、智慧安防、智慧电力等应用场景解决方案和产品。</p>
                    </div>
                    <div class="image animate__animated animate__fadeInRight">
                        <img src="@/assets/about/tel.png" alt="">
                    </div>
                </div>

            </div>
            <div class="culturalConcept">
                <div class="title">
                    CULTURAL CONCEPT
                    <h1>文化理念</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
                <div class="bottom">
                    <div class="text animate__animated animate__fadeInRight ">
                        <p>文化理念是公司成长发展壮大的灵魂内核和共生动力，牵引着公司的前进方向和目标，体现着公司的境界高度和水平，展现着员工的精神风貌和素质。</p>
                        <h4>星空仰望</h4>
                        <p>在哲学和精神层面，放眼世界、目光高远、展现情怀， 怀抱广阔星空天地，寻找思想和前行方向，提升思维层次，满怀责任感、
                            荣誉感和使命感，做有益于国家、社会、人民有意义的事业。</p>
                        <h4>谱写华章</h4>
                        <p>在物质和实践层面，目标明确、责任清晰、步调一致，紧盯频谱理论研究和应用开发领域，聚焦域内主责主业，实施自主创新和自主研发为主战略，致力于理论创新、技术创新、产品创新，引领发展、绘就篇章。 </p>
                        <h4>智胜未来</h4>
                        <p>在理想和目标层面，不懈追求、团结奋斗、勇毅前行，瞄准行业高端前沿，以客户为中心创造价值，以奋斗者为本实现价值，敢为人先、智能取胜、赢得未来，最终建成优秀的现代化创新型高科技公司企业。</p>
                    </div>
                    <div class="image animate__animated  animate__fadeInLeft">
                        <img src="@/assets/home/building.png" alt="">
                    </div>
                </div>
            </div>
            <div class="aptitude">
                <div class="title">
                    AWARDS
                    <h1>资质奖项</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
                <div>
                    <p>中国电子学会科学技术奖一等奖、中国通信学会科学技术奖，一等奖</p>
                    <p>中国发明协会2021年度发明创业奖创新奖一等奖</p>
                    <p>
                        国家科技进步二等奖1项，省部级一等奖4项、二等奖2项、三等奖1项。</p>
                    <p>日内瓦国际发明展金奖2项</p>
                    <p>IET全球创新奖2项，提名奖1项</p>
                </div>
                <div class="img_box">
                    <img src="@/assets/about/img1.png" alt="">
<!--                    <img src="@/assets/about/img2.png" alt="">-->
                    <img src="@/assets/about/img3.png" alt="">
                    <img src="@/assets/about/img4.png" alt="">
                    <img src="@/assets/about/img5.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "About",
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
</script>

<style scoped lang="less">
@import "../styles/about";
</style>
